import { computed } from "vue";
import useCompanyInfoData from "./useCompanyInfoData";

/**
 * Contact email from `api/company-info` (`email`); falls back to the config
 * `public.email` while the backend has no email, so existing clients keep
 * working until their backend is filled in.
 */
export default function useCompanyEmail() {
  const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
  const data = useCompanyInfoData();

  return computed<string>(() => {
    const fromBackend = data.value?.email?.trim();
    return fromBackend || String(config.public.email ?? "");
  });
}
